import { MAX_PARALLEL_AUTO_DOWNLOADS } from "@/config/constants";
import { createFifoSemaphore } from "@/lib/fifoSemaphore";

/**
 * Global concurrency limiter for opt-in auto-downloads.
 *
 * A media-heavy chat mounts many bubbles at once (the list isn't virtualized),
 * so without a cap every eligible bubble would fire its own fetch+decrypt
 * simultaneously — saturating the network and spiking battery on a burst of
 * arrivals. This runs at most `MAX_PARALLEL_AUTO_DOWNLOADS` tasks at a time; the
 * rest wait FIFO and start as slots free. Module-level, so the cap is shared
 * across every bubble.
 *
 * ONLY the auto-download (cache-warming) path uses this. A user-initiated open
 * or download is never throttled — it goes straight through processMediaAttachment.
 *
 * The FIFO accounting lives in the shared createFifoSemaphore; this module is a
 * thin, cap-bound instance of it (the send side has its own — see blobSendQueue).
 */
const queue = createFifoSemaphore(MAX_PARALLEL_AUTO_DOWNLOADS);

/**
 * Run `task` under the concurrency cap. Resolves/rejects with the task's result;
 * the slot is always released (even if the task throws or is aborted).
 */
export const runAutoDownload = queue.run;

/** Test-only: reset the shared counters between cases. */
export const __resetAutoDownloadQueue = queue.reset;
